// NOMBASE — Legacy URL slug redirects (extracted from App.js)
//
// All routes in this module exist purely to forward stale URLs to
// their canonical plural counterparts. They DO NOT render real pages.
// Once analytics show <1% hit rate on any individual legacy slug, the
// matching <Route> can be deleted.
//
// React Router requires <Route> elements to be direct children of
// <Routes>, so this module exports a function that returns a JSX
// fragment of <Route> elements to be spread inside App.js's <Routes>.
import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import { LegacyRewriteRedirect } from './LegacyRewriteRedirect';

// The 13 legacy → canonical redirects added during the global slug
// standardization pass (2026-05-31). Each entry is a literal prefix
// rewrite that preserves trailing path segments + query + hash.
const REWRITES = [
  // Legacy /product/* surfaces (singular → plural products)
  { path: '/product/formula/:formulaId/edit',  from: '/product/formula/',  to: '/products/formulas/' },
  { path: '/product/formula/:formulaId',       from: '/product/formula/',  to: '/products/formulas/' },
  { path: '/product/variants/:variantId',      from: '/product/variants/', to: '/products/variants/' },
  { path: '/product/inventory/:itemId',        from: '/product/inventory/',to: '/products/inventory/' },
  { path: '/product/:productId',               from: '/product/',          to: '/products/' },

  // Network detail pages
  { path: '/network/supplier/:supplierId',         from: '/network/supplier/',     to: '/network/suppliers/' },
  { path: '/network/manufacturer/:manufacturerId', from: '/network/manufacturer/', to: '/network/manufacturers/' },

  // Standalone ingredient detail (drop orphan /brand/ prefix)
  { path: '/brand/ingredients/:ingredientId', from: '/brand/ingredients/', to: '/ingredients/' },

  // Supplier-store public view
  { path: '/supplier/:supplierId/store', from: '/supplier/', to: '/suppliers/' },

  // Public storefronts (singular → plural)
  { path: '/flavor-house/:tenantId',     from: '/flavor-house/',     to: '/flavor-houses/' },
  { path: '/packaging-store/:tenantId',  from: '/packaging-store/',  to: '/packaging-stores/' },
  { path: '/ingredient-store/:tenantId', from: '/ingredient-store/', to: '/ingredient-stores/' },
];

// Static (no-param) legacy redirects that just go to a literal target.
const STATIC_REDIRECTS = [
  { path: '/product',                                  to: '/products' },
  { path: '/product/formula/create',                   to: '/products/formulas/create' },
  { path: '/product/variants/create',                  to: '/products/variants/create' },
  { path: '/product/variants/create/solid-sku',        to: '/products/variants/create/solid-sku' },
  { path: '/product/variants/create/variety-pack',     to: '/products/variants/create/variety-pack' },
];

/**
 * Returns the JSX fragment of <Route> elements for every legacy slug
 * redirect. Call this inside <Routes>{legacyRedirectRoutes()}</Routes>.
 */
export const legacyRedirectRoutes = () => (
  <>
    {STATIC_REDIRECTS.map(({ path, to }) => (
      <Route key={path} path={path} element={<Navigate to={to} replace />} />
    ))}
    {REWRITES.map(({ path, from, to }) => (
      <Route
        key={path}
        path={path}
        element={<LegacyRewriteRedirect from={from} to={to} />}
      />
    ))}
  </>
);

// Exported for testing — lets the regression suite enumerate the
// pairs without re-parsing the JSX.
export const __LEGACY_REWRITES__ = REWRITES;
export const __LEGACY_STATIC_REDIRECTS__ = STATIC_REDIRECTS;
